<template>
  <div class="tinymce-editor" style="margin: 5px 0">
    <editor
      v-if="delay"
      api-key="no-api-key"
      v-model="myValue"
      :init="init"
      :disabled="disabled"
      @onClick="onClick"
    ></editor>
  </div>
</template>

<script>
// import tinymce from 'tinymce/tinymce'
// import Editor from 'tinymce-vue'
// import 'tinymce/themes/silver/theme'
// import 'tinymce/plugins/image'
// import 'tinymce/plugins/link'
// import 'tinymce/plugins/media'
// import 'tinymce/plugins/table'
// import 'tinymce/plugins/lists'
// import 'tinymce/plugins/contextmenu'
// import 'tinymce/plugins/wordcount'
// import 'tinymce/plugins/colorpicker'
// import 'tinymce/plugins/textcolor'
// import 'tinymce/plugins/fullscreen'
export default {
  components: {
    Editor: Editor,
  },
  props: {
    value: {
      type: String,
      required: false,
    },
    triggerChange: {
      type: Boolean,
      default: false,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    plugins: {
      type: [String, Array],
      default: 'lists link media table textcolor wordcount contextmenu fullscreen code image media',
    },
    toolbar1: {
      type: [String, Array],
      default:
        'undo redo | link unlink table | bullist numlist outdent indent | alignleft aligncenter alignright alignjustify',
      branding: false,
    },
    toolbar2: {
      type: [String, Array],
      default:
        'fontselect | fontsizeselect | bold italic underline strikethrough forecolor backcolor | removeformat | fullscreen | code image media',
      branding: false,
    },
    height: {
      type: [String, Number],
      default: 'calc(45vh)',
    },
  },
  data() {
    return {
      //初始化配置
      init: {
        language_url: '/lib/tinymce/langs/langs.js',
        language: JSON.parse(localStorage['pro__Locale']).value,
        skin_url: '/lib/tinymce/skins/lightgray',
        fontsize_formats: '12px 13px 14px 16px 18px 24px 36px 48px 72px',
        font_formats:
          "普惠体='PuHuiTi';微软雅黑='微软雅黑';宋体='宋体';黑体='黑体';ArialNarrow='ArialNarrow';Meiryo UI=Meiryo UI;Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings",
        height: this.height,
        plugins: this.plugins,
        // toolbar: this.toolbar,
        // 工具栏1
        // toolbar1: 'undo redo | styleselect | bold italic | link image',
        toolbar1: this.toolbar1,
        // 工具栏2
        toolbar2: this.toolbar2,
        branding: false,
        menubar: false,
        toolbar_drawer: false,
        images_upload_handler: (blobInfo, success) => {
          const img = 'data:image/jpeg;base64,' + blobInfo.base64()
          success(img)
        },
      },
      delay: false,
      myValue: this.value,
    }
  },
  mounted() {
    tinymce.init({})

    setTimeout(() => {
      this.delay = true
    }, 1)
  },
  methods: {
    onClick(e) {
      this.$emit('onClick', e, tinymce)
    },
    //可以添加一些自己的自定义事件，如清空内容
    clear() {
      this.myValue = ''
    },
  },
  watch: {
    value(newValue) {
      this.myValue = newValue == null ? '' : newValue
    },
    myValue(newValue) {
      if (this.triggerChange) {
        this.$emit('change', newValue)
      } else {
        this.$emit('input', newValue)
      }
    },
  },
}
</script>
<style scoped></style>
